import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import compensationIcon from '../../img/compensation-icon.svg';
import learnIcon from '../../img/learn-icon.svg';
import impactIcon from '../../img/impact-icon.svg';
import locationIcon from '../../img/location-icon.svg';
import './Graduates.css';

class Graduates extends Component {
  render() {
    return (
      <div className="graduates">
        <Grid fluid >
          <Row className="about-company">
            <Fade>
              <Col md={12}>
                <h1 className="page-title"> Graduate Scheme </h1>
              </Col>
            </Fade>
            <Col md={8} className="header">
              <p>
                At Distilled ID we value the best idea, no matter who came up with it.
                Graduate developers can expect to be solving real world problems from
                the moment they start. Distilled ID wants to give you the confidence to
                take ownership of whatever you work on, so that we can build something we
                can all be proud of together.
              </p>
              <p>
                Do you have the curiosity to travel on unbeaten paths? The drive to take
                on any challenge? The courage to take on any responsibility? We're the place
                for you to grow both individually and as a valued member of a dynamic team.
              </p>
              <a className="link" href="mailto:info@distilledID.com">SEND US YOUR CV</a>
            </Col>
            <Col md={2} mdOffset={1} className="positions-container">
              <h5>Open positions</h5>
              <div className="positions">
                <span>Graduate Developer</span>
              </div>
            </Col>
          </Row>
          <Row>
            <div className="our-team">
              <Fade delay={300}><div className="featured img-1" /></Fade>
              <Fade delay={100}><div className="featured img-2" /></Fade>
              <Fade delay={500}><div className="featured img-3" /></Fade>
              <Fade delay={500}><div className="featured img-4" /></Fade>
              <Fade delay={300}><div className="featured img-5" /></Fade>
              <Fade delay={100}><div className="featured img-6" /></Fade>
            </div>
          </Row>
          <Fade>
            <Row className="join-us">
              <Col md={12}>
                <h1>
                  Join our team and help us deliver meaningful change
                </h1>
              </Col>
            </Row>
          </Fade>
          <Row className="benefits">
            <Fade>
              <Col md={4} mdOffset={2} className="benefit">
                <img src={learnIcon} alt="learn and grow" />
                <h1>learn and grow</h1>
                <h2>
                  Join one of the most exciting SaaS companies in Edinburgh, rapidly develop your
                  skills as you explore cutting edge tech.
                </h2>
              </Col>
            </Fade>
            <Fade>
              <Col md={4} className="benefit">
                <img src={impactIcon} alt="impact" />
                <h1>Impact</h1>
                <h2>
                  You will work on real world problems and push code to production environments on a daily basis.
                </h2>
              </Col>
            </Fade>
          </Row>
          <Row className="benefits">
            <Fade>
              <Col md={4} mdOffset={2} className="benefit">
                <img src={compensationIcon} alt="compensation" />
                <h1>Compensation</h1>
                <h2>
                  We offer competitive salaries and a solid company pension package.
                  We’re a rapidly expanding start-up which comes with its own set of
                  reward opportunities.
                </h2>
              </Col>
            </Fade>
            <Fade>
              <Col md={4} className="benefit">
                <img src={locationIcon} alt="location" />
                <h1>Location</h1>
                <h2>
                  Distilled ID is run from some beautiful offices in the heart of Edinburgh.
                  Walking distance from the city center and transport links.
                </h2>
              </Col>
            </Fade>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Graduates;



// WEBPACK FOOTER //
// ./src/components/common/Graduates.js